import { z } from "zod";
export const HealthResponse = z.object({
    status: z.literal("ok"),
    uptime: z.number().nonnegative(),
    version: z.string(),
    startedAt: z.string().datetime(),
});
//# sourceMappingURL=health.js.map